import Swal from "sweetalert2";


/**
     * Parameter should be object
     * @type {Object} data 
     * 
     * @type {red | blue | orange} confirmButtonColor - confirm button color should be eiter red, blue, and orange
     */
export const alert = (data) => {
    const { confirmButtonColor = "blue", icon, iconColor } = data || {}
    const mixinData = {
        customClass: {
            confirmButton: `btn alert-confirm alert-button alert-confirm-button-${confirmButtonColor} ml-2`,
            cancelButton: "btn alert-button alert-cancel-button",
        },
        reverseButtons: true,
        buttonsStyling: false,
    }
    if (icon) {
        mixinData.iconHtml = `<img src="${icon}" class="card-protect"/>`;
    }
    if(iconColor) {
        mixinData.iconColor = iconColor;
    }
    return Swal.mixin({
        ...mixinData,
    });
}


// WEBPACK FOOTER //
// ./src/utils/alert.js